var render = function (_h,_vm) {
var _obj;
var _c=_vm._c;return _c('div',{class:( _obj = {
    'success-area': true,
    'inline': _vm.props.hasOwnProperty('inline')
  }, _obj[_vm.data.staticClass] = !!_vm.data.staticClass, _obj )},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }